import React, { Component } from 'react';
import {connect} from 'react-redux';
import {cekCookies} from '../../../../actions';
import __ from 'lodash';
import Loader from '../../../Loader';
import LoaderModal from '../../../modal/LoaderModal';
import Navbar from '../../navbar/Navbar';
import Sidebar from '../../sidebar/Sidebar';
import { CONFIG } from '../../../../config';
import accountManagement from '../../../../apis/accountManagement';
import { Alert } from 'react-bootstrap';
import Dialog from '@material-ui/core/Dialog';
import ToggleButton from '@material-ui/lab/ToggleButton';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import RemoveRedEyeOutlinedIcon from '@material-ui/icons/RemoveRedEyeOutlined';
import CreateOutlinedIcon from '@material-ui/icons/CreateOutlined';
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined';
import LearningForm from './LearningForm';

class Learning extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            isLoading: false,
            alertShow: false,
            openDialog: false,
            openForm: false,
            resMessage: '',
            dataList: [],
            data: null
        };
    }

    async componentDidMount() {
        document.title = "Learning";
        this.setState({
            isFetching: true
        });
        await this.props.cekCookies();

        if(!__.isEmpty(this.props.account)) {
            this.getLearning();
        }
        this.setState({
            isFetching: false
        });
        console.timeEnd('Learning time');
    }

    getLearning = async() => {
        this.setState({
            isLoading: true
        });

        const res = await accountManagement.get(CONFIG.LEARNING_GET_LIST + this.props.account.idSekolah + '/' + this.props.account.idGuru)
        .catch(function(error) {
            console.error('getLearning', error);
        });

        if (res) {
            if(res.data.code === "200") {
                this.setState({
                    dataList: res.data.data
                });
            }
            else {
                this.setState({
                    dataList: [],
                    resMessage: res.msg
                });
            }

            this.setState({
                isLoading: false
            });
        }
    }

    handleSearch() {

    }

    handleForm(data) {
        this.setState({
            openForm: true,
            data: data
        })
    }

    onFormSubmit = async() => {
        console.info("onFormSubmit");
    }

    handleBack = () => {
        this.setState({
            openForm: false,
            data: null
        })

        this.getLearning();
    }

    onDelete = async(id) => {
        this.setState({
            isFetching: true,
            openDialog: false
        });
        const res = await accountManagement.delete(CONFIG.LEARNING_DEL_RENC_BELAJAR + id)
        .catch(function(error) {
            console.error('onDelete', error);
        });

        if (res) {
            if(res.data.code === '200') {
                this.setState({
                    dataList: this.state.dataList.filter(item => item.idRencana !== id)
                })
            }
            this.setState({
                data: null,
                isFetching: false,
                resMessage: res.data.msg,
                alertShow: true
            });
        }
    }

    render() {
        console.groupCollapsed('Render Learning Cek State/Props')
        console.info('State', this.state);
        console.info('Props', this.props);
        console.groupEnd();

        const { dataList, openForm } = this.state;
        let learningForm;
        if(openForm) {
            learningForm = <LearningForm onFormSubmit={this.onFormSubmit} handleBack={this.handleBack}
                data={this.state.data} idGuru={this.props.account.idGuru} idSekolah={this.props.account.idSekolah} />
        }

        return (
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching}/>
                <Sidebar account={this.props.account}/>
                <div id="content" style={{ paddingBottom: '50px' }}>
                    <Navbar title={'Learning'}/>
                    {this.loadAlert()}

                    { !openForm &&
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-6">
                                    <button className="btn btn-primary" onClick={() => this.handleForm(null) }>
                                        Tambah
                                    </button>
                                    &nbsp;
                                </div>

                                <div className="col-sm-6 ">
                                    <input type="text" className="form-control pull-right" style={{width:'60%'}} placeholder="search here ..." onKeyUp={this.handleSearch}/>
                                </div>
                            </div>

                            {this.loading()}
                            { !this.state.isLoading &&
                                <div className="mt-2">
                                    { dataList.map((data, i) =>
                                        <div className="card" style={{ marginBottom: '5px' }} key={i}>
                                            <div className="card-header">
                                                <div className="row">
                                                    <div className="col-sm-4 col-xs-4">
                                                        {i+1}. <span>{data.judul}</span>
                                                    </div>

                                                    <div className="col-sm-4 col-xs-4">
                                                        <small>{data.startDate} <i>s/d</i> {data.endDate}</small>
                                                    </div>

                                                    <div className="col-sm-2 col-xs-2">
                                                        <small>{data.tahunAjaran}</small>
                                                    </div>

                                                    <div className="col-sm-2 col-xs-2">
                                                        {/* <div className="btn-group" style={{ width: '100%' }}>
                                                            <button className="btn btn-outline-primary btn-sm dropdown-toggle" data-toggle="dropdown">
                                                                Action
                                                            </button>

                                                            <div className="dropdown-menu">
                                                                <button className="btn dropdown-item">
                                                                    View
                                                                </button>
                                                                <div className="dropdown-divider">&nbsp;</div>

                                                                <button className="btn dropdown-item" onClick={() => this.handleForm(data)}>
                                                                    Edit
                                                                </button>
                                                                <div className="dropdown-divider">&nbsp;</div>

                                                                <button className="btn dropdown-item" onClick={() => this.handleDialog(data)}>
                                                                    Hapus
                                                                </button>
                                                            </div>
                                                        </div> */}
                                                        {/* <ToggleButton ><RemoveRedEyeOutlinedIcon fontSize="small"/></ToggleButton> */}
                                                        <ToggleButton title="Edit" onClick={() => this.handleForm(data)}><CreateOutlinedIcon fontSize="small" color="primary"/></ToggleButton>
                                                        <ToggleButton title="Hapus" onClick={() => this.handleDialog(data)}><DeleteForeverOutlinedIcon fontSize="small" color="secondary"/></ToggleButton>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            }
                        </div>
                    }

                    {learningForm}
                    {this.confirmDialog()}
                </div>
            </div>
        );
    }

    loading = () => {
        if(this.state.isLoading) {
            return(
                <Loader />
            )
        }
    }

    loadAlert = () => {
        const {alertShow } = this.state;

        if (alertShow) {
          return (
            <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>
                <strong>{this.state.resMessage}</strong>
            </Alert>
          );
        }
    }

    handleDialog = (data) => {
        this.setState({
            openDialog: true,
            data: data
        })
    }

    confirmDialog() {
        const { openDialog, data } = this.state;
        const handleClose = () => {
            this.setState({
                openDialog: false,
                data: null
            })
        };
        let title = '';

        if(data !== null) {
            title = data.judul
        }

        return (
            <Dialog open={openDialog} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                    Perhatian...!!
                </DialogTitle>

                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Konfirmasi Hapus Jadwal Learning <strong>{title}</strong> ?
                    </DialogContentText>
                </DialogContent>

                <DialogActions>
                    <button className="btn btn-danger" onClick={handleClose}> Tidak </button>
                    <button className="btn btn-success" onClick={() => this.onDelete(data.idRencana)} autoFocus> Ya </button>
                </DialogActions>
            </Dialog>
        )
    }
}

const mapStateToProps = (state) => {
    return{
        account: state.account
    };
}

export default connect(mapStateToProps, {cekCookies})(Learning);